import { CSSObject, forBrands, styled, Theme } from '@core-ui/react-stitch';
import { CategoryBannerContainerProps } from './types';

const getDesktopStylesForGap = () => ({
  maxWidth: '1920px',
  margin: 'auto',
});

const getDesktopStylesForOldNavy = () => ({
  maxWidth: '1280px',
  padding: 0,
});

const getDesktopStylesForAthleta = () => ({
  maxWidth: '100%',
  padding: 0,
});

const getDesktopStylesForBananaRepublic = () => ({
  maxWidth: '1280px',
  padding: '0 1rem',
});

const getDesktopStylesForBananaRepublicRedesign = () => ({
  maxWidth: '1920px',
  margin: 'auto',
});

const getCategoryBannerContainerStyles = (
  theme: Theme,
  isBRRedesignEnabled: boolean
) =>
  forBrands(theme, {
    gap: getDesktopStylesForGap,
    gapfs: getDesktopStylesForGap,
    on: getDesktopStylesForOldNavy,
    at: getDesktopStylesForAthleta,
    br: isBRRedesignEnabled
      ? getDesktopStylesForBananaRepublicRedesign
      : getDesktopStylesForBananaRepublic,
    brfs: isBRRedesignEnabled
      ? getDesktopStylesForBananaRepublicRedesign
      : getDesktopStylesForBananaRepublic,
  }) as CSSObject;

const CategoryBannerContainer = styled.div(
  ({ theme, isBRRedesignEnabled }: CategoryBannerContainerProps) => ({
    margin: 'auto',
    overflow: 'hidden',
    ...getCategoryBannerContainerStyles(theme, isBRRedesignEnabled),
  })
);

export default CategoryBannerContainer;
